import { SettingConst } from '@faire/web-api--source/types';

/**
 * How long we should wait for the frontend hCaptcha API call before timing out and proceeding with the login
 *  without an hCaptcha token.
 *  Companion to HCAPTCHA_FRONTEND_TIMEOUT_MS.
 *  Allows us to test the timeout via a separate setting in order to bundle interventions into a single
 *  experiment.
 */
export const EXPERIMENTAL_HCAPTCHA_FRONTEND_TIMEOUT_MS =
  'EXPERIMENTAL_HCAPTCHA_FRONTEND_TIMEOUT_MS' as SettingConst<
    'EXPERIMENTAL_HCAPTCHA_FRONTEND_TIMEOUT_MS',
    number,
    'RETAILER' | 'VISITOR_WEB'
  >;
